var createStylesheet = (chunkId, fullhref, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	(function(linkTag) {
	                if (typeof _N_E_STYLE_LOAD === 'function') {
	                    const { href, onload, onerror } = linkTag;
	                    _N_E_STYLE_LOAD(href.indexOf(window.location.origin) === 0 ? new URL(href).pathname : href).then(()=>onload == null ? void 0 : onload.call(linkTag, {
	                            type: 'load'
	                        }), ()=>onerror == null ? void 0 : onerror.call(linkTag, {}));
	                } else {
	                    document.head.appendChild(linkTag);
	                }
	            })(linkTag)
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	78068: 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"1565":1,"2239":1,"2250":1,"3992":1,"4187":1,"5561":1,"5880":1,"6161":1,"6845":1,"6906":1,"7796":1,"8070":1,"8524":1,"8922":1,"9458":1,"11721":1,"20436":1,"23323":1,"25846":1,"25851":1,"27072":1,"28739":1,"30722":1,"32155":1,"32814":1,"33244":1,"33714":1,"34068":1,"36029":1,"37697":1,"38001":1,"39079":1,"39792":1,"40133":1,"40301":1,"40687":1,"41179":1,"43223":1,"43348":1,"43962":1,"44473":1,"44509":1,"45055":1,"45392":1,"46383":1,"46524":1,"46758":1,"47269":1,"47869":1,"51085":1,"51409":1,"51918":1,"52430":1,"53590":1,"54172":1,"54955":1,"55930":1,"56369":1,"56624":1,"57278":1,"58002":1,"58427":1,"59605":1,"61846":1,"63657":1,"64034":1,"66453":1,"68145":1,"68950":1,"69106":1,"71228":1,"73847":1,"74659":1,"74858":1,"75527":1,"76740":1,"76876":1,"80047":1,"81314":1,"81395":1,"81577":1,"81653":1,"81744":1,"81928":1,"83462":1,"86226":1,"87451":1,"88063":1,"88092":1,"88475":1,"91173":1,"91473":1,"93236":1,"93367":1,"95509":1,"96178":1,"97670":1,"97964":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr